module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/main-settings/add-nationality/add-nationality.component.css
// module id = ./src/app/main-settings/add-nationality/add-nationality.component.css
// module chunks = main